/* eslint-disable react/jsx-no-target-blank */
import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import cx from 'classnames';
import { ModalNext, ModalBody } from '@jutro/components';
import { Flex } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WMICButton, WMICModalHeader } from 'wmic-pe-components-platform-react';
import { WMICRichTextUtil } from 'wmic-portals-utils-js';
import metadata from './openHelpModalPopup.metadata.json5';
import styles from './openHelpModalPopup.module.scss';
import headerMessages from '../WMICPageHeaderComponent.messages';
import messages from './openHelpModalPopup.messages';
import { TranslatorContext } from '@jutro/legacy/locale';

function OpenHelpModalPopup(props) {
    const { actionBtnLabel, isOpen, onResolve } = props;
    const translator = useContext(TranslatorContext);

    const handleSave = () => {
        onResolve(actionBtnLabel);
    };

    const getTranslatedMessage = key => WMICRichTextUtil.translateRichText(translator(key));

    const getBrokerHelpEmail = () => {
        const emailAddress = translator(messages.brokerEmailAddress);
        return (
            <>
                {getTranslatedMessage(messages.brokerEmail)}
                <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </>
        );
    };

    const getBrokerPortalLink = () => (
        <>
            {translator(messages.forMoreInfo)}
            <a href={translator(messages.portalLink)} target="_blank">
                {translator(messages.portalLinkText)}
            </a>
        </>
    );

    const overrides = {
        underWriterHeader: {
            content: getTranslatedMessage(messages.contactUnderwriter),
        },
        personalLinesTollFreeNumber: {
            content: getTranslatedMessage(messages.personalLinesTollFreeNumber),
        },
        commercialLinesTollFreeNumber: {
            content: getTranslatedMessage(messages.commercialLinesTollFreeNumber),
        },
        billingInquiryHeader: {
            content: getTranslatedMessage(messages.billingInquiryFor),
        },
        billingInquiryTollFreeNumber: {
            content: getTranslatedMessage(messages.billingInquiryTollFreeNumber),
        },
        brokerHelpHeader: {
            content: getTranslatedMessage(messages.brokerHelp),
        },
        brokerHelpTollFreeNumber: {
            content: getTranslatedMessage(messages.brokerHelpTollFreeNumber),
        },
        brokerHelpEmail: {
            content: getBrokerHelpEmail(),
        },
        brokerPortalNavigate: {
            content: getBrokerPortalLink(),
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
    };

    const footerLayoutProps = {
        justifyContent: 'right',
        alignItems: 'middle',
        wrap: 'reverse',
    };

    const modalContainerClass = cx('wmicSelectAllLinksModal', styles.modalContainer);
    return (
        <ModalNext isOpen={isOpen} className={modalContainerClass}>
            <WMICModalHeader title={headerMessages.contactUs} />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </ModalBody>
            <Flex className={styles.modalFooter} {...footerLayoutProps}>
                <WMICButton onClick={handleSave} type="primary">
                    {actionBtnLabel}
                </WMICButton>
            </Flex>
        </ModalNext>
    );
}

OpenHelpModalPopup.propTypes = {
    actionBtnLabel: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func.isRequired,
};

export default OpenHelpModalPopup;
